import React from 'react';
import {
  Center,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  useDisclosure,
  HStack,
  Text,
  Button,
  Image,
  RadioGroup,
  Radio,
  chakra,
} from '@chakra-ui/react';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/form-control';
import { useField } from 'formik';
import { ChevronDownIcon } from '@chakra-ui/icons';

const SelectFieldId = ({ label, options, placeholder, onChangeId, image, textButton, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const { value } = meta;
  const { setValue } = helpers;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const colorErro = meta.error ? { colorScheme: 'red' } : {};

  let selectedOption = options.find((opt) => opt.id === value);

  return (
    <FormControl isInvalid={meta.error}>
      <FormLabel>{label}</FormLabel>
      <Center>
        <Button
          onClick={onOpen}
          rightIcon={<ChevronDownIcon />}
          w="100%"
          maxW="380px"
          display="flex"
          justifyContent="flex-start"
          pl={image ? 4 : 3}
          pr={2}
          {...field}
          {...props}
          {...colorErro}
        >
          <HStack spacing={0} w="100%" justify="center" textAlign="center">
            {image && <Image src={image} boxSize="20px" mr="16px" />}
            <Text fontWeight="bold" color="#757575" textAlign="center">
              {textButton}
            </Text>
          </HStack>
        </Button>
      </Center>
      <Drawer placement="bottom" onClose={onClose} isOpen={isOpen} size="xs">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader>Selecione</DrawerHeader>
          <DrawerBody>
            <RadioGroup
              w="100%"
              value={String(value)}
              pb={5}
              onChange={(val) => {
                const idSelecionado = Number(val);
                setValue(idSelecionado); 
                onChangeId?.(idSelecionado); 
                onClose();
              }}
            >
              {options.map((opt) => (
                <Radio key={opt.id} value={String(opt.id)} padding="1em">
                  <chakra.p fontWeight="bold" fontSize="sm">
                    <Text color="#757575">{opt.label}</Text>
                  </chakra.p>
                </Radio>
              ))}
            </RadioGroup>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <FormErrorMessage>{meta.error}</FormErrorMessage>
    </FormControl>
  );
};

export default SelectFieldId;
